import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
import StudentTranscript from "./routes/StudentTranscript";
export default store => ({
  path: "students",
  component: withAsyncRouteLoading(
    () =>
      Promise.all([
        import(/* webpackChunkName: "transcript-chunk" */ "./components"),
      ]).then(([importedModule0]) => {
        const component = importedModule0.default;
        return component;
      })
    //.catch(err => {
    //   throw err;
    // })
  ),
  childRoutes: [StudentTranscript(store)],
});
